import { useCallback } from 'react';

import {
	type CreatePromptRequest,
	type GetPromptResponse,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	type AssistanceServiceInjectedParams,
	type AssistanceServiceInputParam,
	createHookWithAssistanceService,
} from '@atlassian/conversation-assistant-service/services/assistance-service/main';

type UseCreatePromptControllerProps = AssistanceServiceInjectedParams;

export type UseCreatePromptControllerResult = {
	createPrompt: (payload: CreatePromptRequest) => Promise<GetPromptResponse>;
};

/**
 * Returns a function to create a prompt via the assistance service POST /api/v2/prompts endpoint.
 */
export const useCreatePromptController: (
	props: Omit<AssistanceServiceInjectedParams, 'assistanceServiceInjectedParams'> &
		AssistanceServiceInputParam,
) => UseCreatePromptControllerResult = createHookWithAssistanceService(
	({
		assistanceServiceInjectedParams: { assistanceService },
	}: UseCreatePromptControllerProps): UseCreatePromptControllerResult => {
		const createPrompt = useCallback(
			(payload: CreatePromptRequest) => assistanceService.createPrompt(payload),
			[assistanceService],
		);
		return { createPrompt };
	},
);
